"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeployedExtraProcessor = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ethTypes = require("@blockwell/eth-types");
var _util = require("@blockwell/util");
var _util2 = require("./util");
var _apiminerClient = require("@blockwell/apiminer-client");
class DeployedExtraProcessor {
  constructor() {
    (0, _defineProperty2.default)(this, "key", "deployed");
  }
  async process(parameters, submission) {
    let deployed = [];
    for (let {
      event,
      step
    } of (0, _util2.findEvents)(submission, /Deployed/)) {
      let address = (0, _ethTypes.ethResolveStringParameter)(event.params, "contractAddress");
      if (address) {
        try {
          // Try 3 times in case there's delay in propagation
          for (let i = 0; i < 3; i++) {
            let contract = await (0, _util2.getTokenData)(parameters.contracts, step.network, address);
            if (contract !== null && contract !== void 0 && contract.bwtype) {
              let type = _apiminerClient.bwTypeMap[contract.bwtype];
              if (type) {
                let dep = {
                  ...contract
                };
                if (type.happ) {
                  dep.happ = `/${type.happ}?net=${dep.network}&contract=${dep.address}`;
                }
                deployed.push(dep);
              }
              break;
            } else {
              await (0, _util.delay)(3000);
            }
          }
        } catch (err) {
          console.error(err);
        }
      }
    }
    return deployed;
  }
}
exports.DeployedExtraProcessor = DeployedExtraProcessor;
//# sourceMappingURL=DeployedExtra.js.map